import { useState } from "react"
import { useRouter } from "next/router"
import { getPaymentPlans } from "@common/network"

import { getPaymentRedirectObject, isNullOrEmpty } from "@common/lib/util"

export function usePlans(returnPageKey: string, project: string, step?: number) {
  const router = useRouter()
  const [paymentRedirectObj, setPaymentRedirectObj] = useState({})
  const { data, isError, isLoading } = getPaymentPlans(
    paymentRedirectObj,
    !isNullOrEmpty(paymentRedirectObj)
  )

  if (isNullOrEmpty(paymentRedirectObj) && router?.query?.customerId) {
    setPaymentRedirectObj(
      getPaymentRedirectObject(router.asPath, step, returnPageKey, project)
    )
  }
  return { data, isError, isLoading }
}
